/**
 * Ejecuta la adición de todos los numeros pasados en entrada.
 * Devuelve el total calculado
 *
 * @param {array<float>} args: la lista de numeros a sumar
 *
 * @return {float} el total
 */

import { getMultiplicator } from './getMultiplicator';

export function add(...args) {
  const multiplicator = getMultiplicator(args);
  const total = args.reduce((acc, cur) => acc + multiplicator * cur, 0);
  return total / multiplicator;
}
